export default __webpack_public_path__ + "static/media/itd.815e4caf.jpg";